// extracted by mini-css-extract-plugin
export default {"statusCell":"StatusCell_statusCell__SJknH","contentWrapper":"StatusCell_contentWrapper__ui6Kq","wasStatus":"StatusCell_wasStatus__qOd1k"};